import { useParams } from "react-router-dom";
import Dashboard from "datasets/pages/dashboards/types/interfaces/dashboard";
import { KeyedMutator, SWRResponse } from "swr";
import { useFetcher } from "~/hooks/useFetcher";
import { V1DashboardListEnvelope, V1DashboardResult } from "~/types/interfaces/catalogDashboards";

const { VITE_CATALOG_API } = import.meta.env;

const adaptItem = (item: V1DashboardResult): Dashboard => ({
  id: item.id,
  displayName: item.display_name ?? item.name,
  description: item.description ?? "",
  sourceUrl: item.source_url ?? "",
  fqn: item.fqn,
  updatedAt: item.updated_at ?? 0,
  published: item.published,
});

const useDatasetDashboards = (id?: string): SWRResponse<Dashboard[]> => {
  const { datasetId = id } = useParams();

  const resp = useFetcher<V1DashboardListEnvelope>(
    datasetId ? `${VITE_CATALOG_API}/v1/datasets/${datasetId}/dashboards?limit=100` : null
  );

  return {
    ...resp,
    data: resp.data ? resp.data.items.map(adaptItem) : undefined,
    mutate: resp.mutate as KeyedMutator<any>,
  } as SWRResponse<Dashboard[]>;
};

export default useDatasetDashboards;
